import EventHandler from '../../../../node_modules/bootstrap/js/src/dom/event-handler'
import SelectorEngine from '../../../../node_modules/bootstrap/js/src/dom/selector-engine'
import BaseComponent from '../../../../node_modules/bootstrap/js/src/base-component'

const NAME = 'projectportfolio'
const SELECTOR_PORTFOLIO = '[data-project-portfolio]'

class ProjectPortfolio extends BaseComponent {
    constructor(element, config) {
        super(element, config)

        this._pageSize = parseInt(element.getAttribute('data-page-size') || '36', 10) || 36;
        this._visibleLimit = this._pageSize;

        this._items = SelectorEngine.find('[data-project-item]', element).map((el) => ({
            el,
            categories: JSON.parse(el.getAttribute('data-project-categories') || '[]'),
            locations: JSON.parse(el.getAttribute('data-project-locations') || '[]')
        }));

        this._categoryBtns = SelectorEngine.find('[data-filter-category-btn]', element);
        this._locationBtns = SelectorEngine.find('[data-filter-location-btn]', element);
        this._locationWrapper = SelectorEngine.findOne('[data-filter-location-wrapper]', element);
        this._locationInput = SelectorEngine.findOne('[data-filter-location-input]', element);
        this._locationDropdown = SelectorEngine.findOne('[data-filter-location-dropdown]', element);
        this._locationEmpty = SelectorEngine.findOne('[data-filter-location-empty]', element);

        this._statusEl = SelectorEngine.findOne('[data-filter-status]', element);
        this._activeGroupEl = SelectorEngine.findOne('[data-filter-active-group]', element);
        this._activeChipsEl = SelectorEngine.findOne('[data-filter-active-chips]', element);
        this._clearBtns = SelectorEngine.find('[data-filter-clear]', element);
        this._emptyStateEl = SelectorEngine.findOne('[data-filter-empty]', element);

        this._loadMoreContainer = SelectorEngine.findOne('[data-load-more-container]', element);
        this._loadMoreBtn = SelectorEngine.findOne('[data-load-more-btn]', element);
        this._loadAllBtn = SelectorEngine.findOne('[data-load-all-btn]', element);

        this._activeCategories = new Set();
        this._activeLocations = new Set();

        this._bindEvents();
        this._restoreFromUrl();
        this._update();
    }

    static get NAME() {
        return NAME;
    }

    _bindEvents() {
        for (const btn of this._categoryBtns) {
            const cat = btn.getAttribute('data-filter-category-btn');
            EventHandler.on(btn, 'click', (e) => {
                e.preventDefault();
                this._toggleSet(this._activeCategories, cat);
                this._syncUrl();
                this._update();
            });
        }

        for (const btn of this._locationBtns) {
            const loc = btn.getAttribute('data-filter-location-btn');
            EventHandler.on(btn, 'click', (e) => {
                e.preventDefault();
                this._toggleSet(this._activeLocations, loc);
                if (this._locationInput && this._locationInput.value) {
                    this._locationInput.value = '';
                    this._filterLocationSearch('');
                }
                this._syncUrl();
                this._update();
            });
        }

        if (this._locationInput && this._locationWrapper) {
            EventHandler.on(this._locationInput, 'focus', () => {
                this._openLocationDropdown();
            });

            EventHandler.on(this._locationInput, 'click', () => {
                this._openLocationDropdown();
            });

            EventHandler.on(this._locationInput, 'input', () => {
                this._openLocationDropdown();
                this._filterLocationSearch(this._locationInput.value);
            });

            EventHandler.on(this._locationInput, 'keydown', (e) => {
                if (e.key === 'Escape') {
                    this._closeLocationDropdown();
                    this._locationInput.blur();
                }
            });

            EventHandler.on(this._locationWrapper, 'click', (e) => {
                e.stopPropagation();
            });

            EventHandler.on(document, 'click', () => {
                this._closeLocationDropdown();
            });
        }

        for (const clearBtn of this._clearBtns) {
            EventHandler.on(clearBtn, 'click', (e) => {
                e.preventDefault();
                this._activeCategories.clear();
                this._activeLocations.clear();
                if (this._locationInput) {
                    this._locationInput.value = '';
                    this._filterLocationSearch('');
                }
                this._syncUrl();
                this._update();
            });
        }

        if (this._loadMoreBtn) {
            EventHandler.on(this._loadMoreBtn, 'click', (e) => {
                e.preventDefault();
                this._visibleLimit += this._pageSize;
                this._update();
            });
        }

        if (this._loadAllBtn) {
            EventHandler.on(this._loadAllBtn, 'click', (e) => {
                e.preventDefault();
                this._visibleLimit = this._items.length;
                this._update();
            });
        }

        EventHandler.on(window, 'popstate', () => {
            this._restoreFromUrl();
            this._update();
        });
    }

    _openLocationDropdown() {
        if (!this._locationWrapper || !this._locationInput) return;
        this._locationWrapper.classList.add('is-open');
        this._locationInput.setAttribute('aria-expanded', 'true');
    }

    _closeLocationDropdown() {
        if (!this._locationWrapper || !this._locationInput) return;
        this._locationWrapper.classList.remove('is-open');
        this._locationInput.setAttribute('aria-expanded', 'false');
    }

    _toggleSet(set, value) {
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
    }

    _restoreFromUrl() {
        this._activeCategories.clear();
        this._activeLocations.clear();

        const params = new URLSearchParams(window.location.search);
        const validCategories = new Map(
            this._categoryBtns.map((b) => {
                const name = b.getAttribute('data-filter-category-btn');
                return [name.toLowerCase(), name];
            })
        );
        const validLocations = new Map(
            this._locationBtns.map((b) => {
                const name = b.getAttribute('data-filter-location-btn');
                return [name.toLowerCase(), name];
            })
        );

        for (const rawCat of params.getAll('category')) {
            for (const part of rawCat.split(',')) {
                const canonical = validCategories.get(part.trim().toLowerCase());
                if (canonical) {
                    this._activeCategories.add(canonical);
                }
            }
        }

        for (const rawLoc of params.getAll('location')) {
            for (const part of rawLoc.split(',')) {
                const canonical = validLocations.get(part.trim().toLowerCase());
                if (canonical) {
                    this._activeLocations.add(canonical);
                }
            }
        }
    }

    _syncUrl() {
        const url = new URL(window.location.href);
        url.searchParams.delete('category');
        url.searchParams.delete('location');

        for (const cat of this._activeCategories) {
            url.searchParams.append('category', cat);
        }
        for (const loc of this._activeLocations) {
            url.searchParams.append('location', loc);
        }

        window.history.replaceState({}, '', url.toString());
    }

    _matchesCategories(item) {
        if (this._activeCategories.size === 0) return true;
        return item.categories.some((c) => this._activeCategories.has(c));
    }

    _matchesLocations(item) {
        if (this._activeLocations.size === 0) return true;
        return item.locations.some((l) => this._activeLocations.has(l));
    }

    _update() {
        const hasFilters = this._activeCategories.size > 0 || this._activeLocations.size > 0;

        // 1. Filter items & apply progressive batching when no filters are active
        let matchedCount = 0;
        let shownCount = 0;

        for (const item of this._items) {
            const matches = this._matchesCategories(item) && this._matchesLocations(item);
            if (!matches) {
                item.el.classList.add('project-card--filtered-out');
                item.el.classList.remove('project-card--paged');
                continue;
            }

            matchedCount++;
            item.el.classList.remove('project-card--filtered-out');

            if (!hasFilters && matchedCount > this._visibleLimit) {
                item.el.classList.add('project-card--paged');
            } else {
                item.el.classList.remove('project-card--paged');
                shownCount++;
            }
        }

        // 2. Cross-update Category counts (filtered by currently active Locations)
        for (const btn of this._categoryBtns) {
            const cat = btn.getAttribute('data-filter-category-btn');
            const isSelected = this._activeCategories.has(cat);
            let availableCount = 0;
            for (const item of this._items) {
                if (this._matchesLocations(item) && item.categories.includes(cat)) {
                    availableCount++;
                }
            }

            btn.classList.toggle('active', isSelected);
            btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

            const countSpan = SelectorEngine.findOne('[data-filter-count]', btn);
            if (countSpan) {
                countSpan.textContent = `${availableCount}`;
            }

            if (availableCount === 0 && !isSelected) {
                btn.classList.add('d-none');
            } else {
                btn.classList.remove('d-none');
            }
        }

        // 3. Cross-update Location counts (filtered by currently active Categories)
        for (const btn of this._locationBtns) {
            const loc = btn.getAttribute('data-filter-location-btn');
            const isSelected = this._activeLocations.has(loc);
            let availableCount = 0;
            for (const item of this._items) {
                if (this._matchesCategories(item) && item.locations.includes(loc)) {
                    availableCount++;
                }
            }

            btn.classList.toggle('active', isSelected);
            btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

            const countSpan = SelectorEngine.findOne('[data-filter-count]', btn);
            if (countSpan) {
                countSpan.textContent = `${availableCount}`;
            }

            btn.setAttribute('data-available-count', `${availableCount}`);
            if (availableCount === 0 && !isSelected) {
                btn.classList.add('d-none');
            } else {
                btn.classList.remove('d-none');
            }
        }

        // Re-apply text search inside the location dropdown if user has typed something
        if (this._locationInput) {
            this._filterLocationSearch(this._locationInput.value);
        }

        // 4. Update status text & active filter chips
        const total = this._items.length;
        if (this._statusEl) {
            if (hasFilters) {
                this._statusEl.textContent = `Showing ${matchedCount} of ${total} projects`;
            } else {
                this._statusEl.textContent = `Showing ${shownCount} of ${total} projects`;
            }
        }

        if (this._activeGroupEl && this._activeChipsEl) {
            this._activeChipsEl.innerHTML = '';
            if (hasFilters) {
                this._activeGroupEl.classList.remove('d-none');
                for (const cat of this._activeCategories) {
                    this._activeChipsEl.appendChild(this._createActiveChip(cat, 'Category', () => {
                        this._activeCategories.delete(cat);
                        this._syncUrl();
                        this._update();
                    }));
                }
                for (const loc of this._activeLocations) {
                    this._activeChipsEl.appendChild(this._createActiveChip(loc, 'Location', () => {
                        this._activeLocations.delete(loc);
                        this._syncUrl();
                        this._update();
                    }));
                }
            } else {
                this._activeGroupEl.classList.add('d-none');
            }
        }

        // 5. Empty state
        if (this._emptyStateEl) {
            this._emptyStateEl.classList.toggle('d-none', matchedCount > 0);
        }

        // 6. Load More bar visibility
        if (this._loadMoreContainer) {
            const hasMoreUnfiltered = !hasFilters && shownCount < matchedCount;
            this._loadMoreContainer.classList.toggle('d-none', !hasMoreUnfiltered);
            if (this._loadMoreBtn) {
                const remaining = matchedCount - shownCount;
                const nextBatch = Math.min(this._pageSize, remaining);
                this._loadMoreBtn.textContent = `Load ${nextBatch} More Projects`;
            }
        }
    }

    _createActiveChip(label, typeLabel, onRemove) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'project-filter--active-chip';
        btn.setAttribute('aria-label', `Remove ${typeLabel.toLowerCase()} filter: ${label}`);
        btn.innerHTML = `<span class="project-filter--chip-label">${label}</span><span class="project-filter--chip-remove" aria-hidden="true">&times;</span>`;
        EventHandler.on(btn, 'click', (e) => {
            e.preventDefault();
            onRemove();
        });
        return btn;
    }

    _filterLocationSearch(query) {
        const normalized = (query || '').trim().toLowerCase();
        let visibleCount = 0;

        for (const btn of this._locationBtns) {
            const loc = (btn.getAttribute('data-filter-location-btn') || '').toLowerCase();
            const availableCount = parseInt(btn.getAttribute('data-available-count') || '1', 10);
            const isSelected = this._activeLocations.has(btn.getAttribute('data-filter-location-btn'));

            if (availableCount === 0 && !isSelected) {
                btn.classList.add('d-none');
                continue;
            }

            if (!normalized || loc.includes(normalized)) {
                btn.classList.remove('d-none');
                visibleCount++;
            } else {
                btn.classList.add('d-none');
            }
        }

        if (this._locationEmpty) {
            this._locationEmpty.classList.toggle('d-none', visibleCount > 0);
        }
    }
}

function initPortfolios() {
    const portfolios = SelectorEngine.find(SELECTOR_PORTFOLIO);
    for (const portfolio of portfolios) {
        ProjectPortfolio.getOrCreateInstance(portfolio);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPortfolios);
} else {
    initPortfolios();
}

export default ProjectPortfolio
